export const throttleF = (fn: Function, threshold?: number): Function => {
    let start: number = 0;
    threshold = threshold || 1000;
    return function() {
        // @ts-ignore
        const context: any = this;
        const current: number = new Date().getTime();

        if (!start || current - start >= (threshold as number)) {
            fn.apply(context, arguments);
            start = current;
        }
    };
};

/**
 * 加载
 */
export function loading(loadingKey: string = 'loading') {
    return function(target: any, propertyKey: string, propertyDescriptor: PropertyDescriptor) {
        const method = propertyDescriptor.value;
        propertyDescriptor.value = async function() {
            this[loadingKey] = true;
            try {
                const res = await method.apply(this, arguments);
                return res;
            } catch (e) {
                console.log(e);
            } finally {
                // @ts-ignore
                this[loadingKey] = false;
            }
        };
        return propertyDescriptor;
    };
}

/**
 * 确认
 */
/**
 * 确认
 */
export function confirm(operationName: string, short: boolean = true) {
    return function(target: any, propertyKey: string, propertyDescriptor: PropertyDescriptor) {
        const method = propertyDescriptor.value;
        propertyDescriptor.value = async function() {
            try {
                const message = short ? `${operationName}` : operationName;
                await this.$dialog.confirm({ message });
                const res = await method.apply(this, arguments);
                return res;
            } catch (e) {
                console.log(e);
            }
        };
        return propertyDescriptor;
    };
}

/**
 * 加载
 */
export function vantLoading() {
    return function(target: any, propertyKey: string, propertyDescriptor: PropertyDescriptor) {
        const method = propertyDescriptor.value;
        propertyDescriptor.value = async function() {
            this.$toast.loading({ forbidClick: true, duration: 0 });
            try {
                const res = await method.apply(this, arguments);
                return res;
            } catch (e) {
                console.log(e);
            } finally {
                this.$toast.clear();
            }
        };
        return propertyDescriptor;
    };
}

/**
 * 加载
 */
export function validate(validateMethodKey: string) {
    return function(target: any, propertyKey: string, propertyDescriptor: PropertyDescriptor) {
        const method = propertyDescriptor.value;
        propertyDescriptor.value = async function() {
            const validated = await this[validateMethodKey]();
            if (!validated) { return; }
            const res = await method.apply(this, arguments);
            return res;
        };
        return propertyDescriptor;
    };
}

/**
 * 节流
 * wait 等改的毫秒数
 */
export function throttle(wait?: number) {
    return function(target: any, propertyKey: string, propertyDescriptor: PropertyDescriptor) {
        const method = propertyDescriptor.value;
        propertyDescriptor.value = throttleF(method, wait || 1000);
        return propertyDescriptor;
    };
}
